UploadStudents = new (function () {
  let wrapper;

  this.initForm = () => {
    wrapper = $(".upload_student_wrapper");
    if (!wrapper || !wrapper.length) return;
    Shared.applyFileValidation({
      fileSelector: "#uploads_student_file",
      submitSelector: ".upload_student_wrapper button[type='submit']",
    });
  };
})();
